import React, { useEffect, useState } from "react";
import { Col, Row, Typography, Tag, Button, Skeleton, Empty } from "antd";
import "./templateCard.css";
import history from "../../../../../routes/history";
import deleteicon from "../../../../../assets/img/deleteicon.png";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  updateGig,
  getJobTemplates,
  getJobDetail,
  updateJobs,
  updateJobsReset,
} from "../../../../../redux/actions";

const TemplateCard = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.postJObReeducer.loading);
  const currentUserId = useSelector((state) => state.profileReducer.user.id);
  const updateLoading = useSelector((state) => state.UpdateJobReducer.loading);

  const deleteTemplate = (event) => {
    dispatch(updateJobs({ isTemplate: false, id: props._id }));
    setTimeout(() => {
      dispatch(
        getJobTemplates({
          type: "saved",
          JobOrderTypeName: location.state.PermanentJob
            ? "Permanent"
            : "Contract",
        })
      );
    }, 1000);
    setTimeout(() => {
      dispatch(updateJobsReset());
    }, 3000);
    // window.location.reload();
    event.stopPropagation();
  };

  useEffect(() => {
    if (updateLoading) {
      dispatch(
        getJobTemplates({
          type: props.templateType,
          JobOrderTypeName: location.state.PermanentJob
            ? "Permanent Gig"
            : "Contract",
        })
      );
    }
  }, [updateLoading]);

  const handleclick = (event) => {
    history.push({
      pathname: `/jobdetail/${props._id}`,
      state: {
        ...(location?.state || {}),
        id: props._id,
        PermanentJob: location.state.PermanentJob,
        fromTemplate: true,
        screen: "My Template",
      },
    });
    event.stopPropagation();
  };

  let skillDetails = props.Skills?.map((item) => {
    return {
      skillName: item.SkillName,
      SkillPercent: item.SkillPercent,
      isDisable: true,
    };
  });

  let industryDetails = props.Industry?.map((item) => {
    return {
      industryName: item.IndustryName,
      industryPercent: item.IndustryPercent ? item.IndustryPercent : 0,
      isDisable: true,
    };
  });

  const postJobWithTemplate = () => {
    let skillDetails = props.JobOrders_Skills.map((item) => {
      return {
        skillName: item?.Skills?.SkillName,
        SkillPercent: item?.SkillPercent,
        isDisable: true,
      };
    });
    let industryDetailss = props?.Industry?.map((item) => {
      return {
        industryName: item.IndustryName,
        industryPercent: item.IndustryPercent ? item.IndustryPercent : 0,
        isDisable: true,
      };
    });
    if (!props.empty)
      history.push({
        pathname: location.state.PermanentJob ? "/per-gig" : "/contract-gig",
        state: {
          ...(location?.state || {}),
          Id: props._id,
          Title: props.Title ? props.Title : "",
          FacilityName: props.FacilityName ? props.FacilityName : "",
          IdealTerms: props ? props?.IdealTerms : [],
          Description: props?.Description,
          WorkAuthorization: props?.WorkAuthorization,
          Role: props?.Role ? props?.Role : "",
          WorkPolicy: props.WorkplacePolicy ? props.WorkplacePolicy : "",
          certificates: props.Certifications,
          Skills: skillDetails,
          // Industry: props.Industry,
          // Industry: industryDetails,
          Industry: industryDetailss,
          Location: props?.Cities?.CityName + ", " + props?.Regions?.Code,
          locobj: {
            CityId: props?.Cities?.CityId,
            CityName: props?.Cities?.CityName,
            CountryId: props?.Countries?.CountryId,
            CountryName: props?.Countries?.CountryName,
            RegionCode: props?.Regions?.Code,
            RegionId: props?.Regions?.RegionId,
            RegionName: props?.Regions?.RegionName,
          },
          Experience: props.ExperienceLevels,
          FromEdit: true,
          NotTemplate: false,
          IdealContractLengthName:
            props?.IdealContractLength?.IdealContractLengthName,
          BudgetMin: props?.BudgetMin,
          PermanentJob: location.state.PermanentJob ? true : false,
          isTemplate: props?.isTemplate,
          from: "Templates",
          placeId: props?.facilityRating?.placeId,
          openPositions: props?.Position,
          employerName: props?.EmployerName,
        },
      });
  };

  return (
    <>
      <div className="template-card-div">
        <div className="temp-card-parent" onClick={() => postJobWithTemplate()}>
          {loading ? (
            <Skeleton active />
          ) : !props.empty ? (
            <>
              <Row style={{ justifyContent: "space-between" }}>
                {/* <Col>
                  <Tag className='tag'>{currentUserId === props.UserId ? 'saved' : 'Default'}</Tag>
                </Col> */}

                <Col>
                  <Tag className="tag">{props.templateType}</Tag>
                </Col>

                {props.templateType != "default" && (
                  <Col className="created-date">
                    {moment(props.Created).format("MMMM D , YYYY")}
                  </Col>
                )}
              </Row>
              <div className="template-title">{props.Title}</div>

              <div style={{ justifyContent: "space-between" }}>
                <Button size="small" className="view-btn" onClick={handleclick}>
                  <div className="btn-text">View</div>
                </Button>
                {props.templateType == "saved" ? (
                  <img
                    className="delete-icon"
                    onClick={deleteTemplate}
                    src={deleteicon}
                  />
                ) : null}
              </div>
            </>
          ) : (
            <Empty />
          )}
        </div>
      </div>
    </>
  );
};
export default TemplateCard;
